import React from 'react';
import PropTypes from 'prop-types';
import { useNavigate } from '@common/hooks';
import { Link, ButtonGroup, Icon } from '@common/components';
import ArchiveList from 'works/pages/organization/admin-settings/templates-page/onboarding-list-templates/archive-list';
import CloneList from 'works/pages/organization/admin-settings/templates-page/onboarding-list-templates/clone-list';
import { Colors } from 'works/legacy/lib/style-helper';

export function OnboardingListTemplateActions(props) {
  const worksOnboardingListTemplate = props.worksListTemplate;
  const navigate = useNavigate();

  return (
    <ButtonGroup>
      <CloneList
        worksListTemplateId={worksOnboardingListTemplate.id}
        worksListTemplateName={worksOnboardingListTemplate.name}
        onSuccess={() => {
          navigate('/works/admin/templates/compliance-list');
        }}
      >
        <b>Duplicate</b>
      </CloneList>
      <ArchiveList worksListTemplate={worksOnboardingListTemplate} />
      <Link
        className="edit-works-list-template-icon"
        to={`/works/admin/templates/compliance-list/${worksOnboardingListTemplate.id}/edit`}
      >
        <Icon icon="pen" tooltipText="Edit basic information" size="md" />
      </Link>
      <style global jsx>{`
        .edit-works-list-template-icon {
          border-radius: 100%;
          background-color: ${Colors.elm};
          color: ${Colors.white};
          padding: 9px 8px 8px 9px;
        }
      `}</style>
    </ButtonGroup>
  );
}

OnboardingListTemplateActions.propTypes = {
  worksListTemplate: PropTypes.shape({
    id: PropTypes.string,
    name: PropTypes.string.isRequired,
  }).isRequired,
};
